import { render, staticRenderFns } from "./AccountMessage.vue?vue&type=template&id=b98514b6&scoped=true"
import script from "./AccountMessage.vue?vue&type=script&lang=ts"
export * from "./AccountMessage.vue?vue&type=script&lang=ts"
import style0 from "./AccountMessage.vue?vue&type=style&index=0&id=b98514b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98514b6",
  null
  
)

export default component.exports